export const formatSecretTemplate = (obj: Record<string, string>): string =>
  JSON.stringify(obj, null, 2)
